// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"7050aaae","108":"df77b177","248":"3296b99e","263":"fb5f3a4f","484":"c3b07960","504":"d5c0471a","526":"80e6e800","628":"9df9efa3","787":"b0cd7197","850":"ed196e39","863":"b47300b4","874":"63f5ed4c","934":"a8387f22"}[chunkId] + ".chunk.js";
};